import { Card } from '@/components/ui/card';
import { Trophy } from 'lucide-react';

const awards = [
  { year: '2025', title: 'Best Forex Spreads', organization: 'Finance Awards' },
  { year: '2024', title: 'Best Forex Broker of the Year', organization: 'Trading Excellence' },
  { year: '2024', title: 'Top Liquidity Provider', organization: 'FX Week' },
  { year: '2024', title: 'Best Affiliate Program', organization: 'Broker Awards' },
  { year: '2024', title: 'Trusted Broker of the Year', organization: 'Global Finance' },
  { year: '2024', title: 'Best Trading App', organization: 'Mobile Trading' },
];

export const AwardsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            A Leading Broker With Global Awards
          </h2>
        </div>

        {/* Awards Carousel/Grid */}
        <div className="relative overflow-hidden">
          <div className="flex gap-6 animate-scroll-infinite">
            {[...awards, ...awards].map((award, index) => (
              <Card key={index} className="flex-shrink-0 w-64 p-6 text-center border-gray-200 hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Trophy className="h-8 w-8 text-amber-600" />
                </div>
                <div className="text-sm font-semibold text-primary mb-2">{award.year}</div>
                <h3 className="text-base font-bold text-gray-900 mb-1">{award.title}</h3>
                <p className="text-sm text-gray-600">{award.organization}</p>
              </Card>
            ))}
          </div>
        </div>

        <style jsx>{`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll-infinite {
            animation: scroll 30s linear infinite;
          }
        `}</style>
      </div>
    </section>
  );
};

export default AwardsSection;